// pages/PropertyDetail.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './PropertyDetail.css';

// Iconos SVG
const BedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V7H1v10h22v-6c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"/>
  </svg>
);

const BathIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 10V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v3c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.78c-1.16-.41-2.47-.78-3.78-.78-2.38 0-4.52.94-6.22 2.42V7zm17 11c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5z"/>
  </svg>
);

const AreaIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 3v18h18V3H3zm16 16H5V5h14v14zM7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z"/>
  </svg>
);

const FloorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
    <path d="M7 7h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"/>
  </svg>
);

const PriceIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.78-1.18 2.73-3.12 3.16z"/>
  </svg>
);

const CategoryIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2l5.5 9h-11L12 2zm0 3.84L10.5 9h3L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

const PropertiesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
  </svg>
);

const ViewIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
  </svg>
);

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
  </svg>
);

const PropertyDetail = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [activeImage, setActiveImage] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    property: ''
  });
  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: false,
    error: false,
    message: ''
  });

  // CONFIGURACIÓN FÁCIL - CAMBIA ESTA RUTA SEGÚN TU API 
  //const API_BASE_URL = 'https://formspree.io/f/xeorzoak';
  const API_BASE_URL = 'https://formspree.io/f/mblppbgz';
  // Datos reales de los apartamentos
  const propertiesData = {
    'apartamento-401': {
      id: 'apartamento-401',
      title: 'Apartamento 401',
      location: 'Carrera 58 # 82-41, Edificio K58, Barranquilla, Colombia',
      price: '$480.000.000',
      alquiler: '$4.300.000',
      priceType: 'Venta / Alquiler',
      type: 'Venta / Alquiler',
      category: 'Apartamento',
      bedrooms: 1,
      bathrooms: 1,
      area: '50 m²',
      floors: 4,
      views: 156,
      date: 'oct. 3, 2024',
      description: 'Apartamento 401 de 50 metros cuadrados ubicado en el cuarto piso del Edificio K58. Cuenta con sala comedor, cocina, área de labor aparte, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable incluidos.',
      details: {
        habitaciones: 1,
        baños: 1,
        areaConstruida: '50 m²',
        parqueaderos: 1
      },
      images: [
       
        '/images/401/1.jpeg',
        '/images/401/2.jpeg',
        '/images/401/3.jpeg',
        '/images/401/4.jpeg',
        '/images/401/5.jpeg'
      ],
      features: [
        'Sala comedor integrada',
        'Cocina completa',
        'Área de labor independiente',
        'Dormitorio principal con clóset',
        'Baño completo',
        'Internet incluido',
        'Cable incluido',
        'Servicios al día',
        'Parqueadero privado',
        'Vigilancia 24/7',
        'Piscina',
        'Baño turco',
        'Zona de barbecue',
        'Terraza',
        'Parque infantil',
        'Parqueadero de visitantes'
      ],
      agent: {
        name: 'Jose Daniel Martinez',
        phone: '3022966560',
        email: 'josedanielmartinez2@gmail.com',
        avatar: 'https://inmobiliaria.kosari.net/storage/captura-de-pantalla-2025-09-22-142633-150x150.png',
        properties: 'Más propiedades de este agente'
      },
      videoUrl: 'https://www.youtube.com/embed/PIuYy-yKCRU',
      coordinates: {
        lat: 11.00957,
        lng: -74.81189
      }
    },
    'apartamento-602': {
      id: 'apartamento-602',
      title: 'Apartamento 602',
      location: 'Carrera 58 # 82-41, Edificio K58, Barranquilla, Colombia',
      price: '$380,000.000',
      alquiler : '3.500.000',
      priceType: 'Venta / Alquiler',
      type: 'Venta / Alquiler',
      category: 'Apartamento',
      bedrooms: 1,
      bathrooms: 1,
      area: '41 m²',
      floors: 6,
      views: 142,
      date: 'oct. 3, 2025',
      description: 'Apartamento 602 de 41 metros cuadrados ubicado en el sexto piso del Edificio K58. Cuenta con sala, cocina, pequeño espacio para área de labor, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable incluidos.',
      details: {
        habitaciones: 1,
        baños: 1,
        areaConstruida: '41 m²',
        parqueaderos: 1
      },
      images: [
   
        '/images/602/1.jpeg',
        '/images/602/2.jpeg',
        '/images/602/3.jpeg',
        '/images/602/4.jpeg',
        '/images/602/5.jpeg'
      ],
      features: [
        'Sala de estar',
        'Cocina equipada',
        'Espacio para área de labor',
        'Dormitorio con clóset',
        'Baño completo',
        'Internet incluido',
        'Cable incluido',
        'Servicios al día',
        'Parqueadero privado',
        'Vigilancia 24/7',
        'Piscina',
        'Baño turco',
        'Zona de barbecue',
        'Terraza',
        'Parque infantil',
        'Parqueadero de visitantes'
      ],
      agent: {
        name: 'Jose Daniel Martinez',
        phone: '3022966560',
        email: 'josedanielmartinez2@gmail.com',
        avatar: 'https://inmobiliaria.kosari.net/storage/captura-de-pantalla-2025-09-22-142633-150x150.png',
        properties: 'Más propiedades de este agente'
      },
      videoUrl: 'https://www.youtube.com/embed/3ovfzHBPAM8',
      coordinates: {
        lat: 11.00957,
        lng: -74.81189
      }
    },
    'apartamento-702': {
      id: 'apartamento-702',
      title: 'Apartamento 702',
      location: 'Carrera 58 # 82-41, Edificio K58, Barranquilla, Colombia',
      price: '$380.000.000',
      alquiler: '$3.500.000',
      priceType: 'Venta / Alquiler',
      type: 'Apartamento',
      category: 'Apartamento',
      bedrooms: 1,
      bathrooms: 1,
      area: '41 m²',
      floors: 7,
      views: 138,
      date: 'oct. 3, 2024',
      description: 'Apartamento 702 de 41 metros cuadrados ubicado en el séptimo piso del Edificio K58. Cuenta con sala, cocina, pequeño espacio para área de labor, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable incluidos.',
      details: {
        habitaciones: 1,
        baños: 1,
        areaConstruida: '41 m²',
        parqueaderos: 1
      },
      images: [

        '/images/702/1.jpeg',
        '/images/702/2.jpeg',
        '/images/702/3.jpeg',
        '/images/702/4.jpeg',
        '/images/702/5.jpeg'
      ],
      features: [
        'Sala de estar',
        'Cocina equipada',
        'Espacio para área de labor',
        'Dormitorio con clóset',
        'Baño completo',
        'Internet incluido',
        'Cable incluido',
        'Servicios al día',
        'Parqueadero privado',
        'Vigilancia 24/7',
        'Piscina',
        'Baño turco',
        'Zona de barbecue',
        'Terraza',
        'Parque infantil',
        'Parqueadero de visitantes'
      ],
      agent: {
        name: 'Jose Daniel Martinez',
        phone: '3022966560',
        email: 'josedanielmartinez2@gmail.com',
        avatar: 'https://inmobiliaria.kosari.net/storage/captura-de-pantalla-2025-09-22-142633-150x150.png',
        properties: 'Más propiedades de este agente'
      },
      videoUrl: 'https://www.youtube.com/embed/-24ufqGjX50',
      coordinates: {
        lat: 11.00957,
        lng: -74.81189
      }
    }
    ,
    'apartamento-303': {
      id: 'apartamento-303',
      title: 'Apartamento 303',
      location: 'Carrera 58 # 82-41, Edificio K58, Barranquilla, Colombia',
      price: '$1.500.000.000',
      priceType: 'Venta',
      type: 'Apartamento',
      category: 'Apartamento',
      bedrooms: 3,
      bathrooms: 3,
      area: '163.31 m²',
      floors: 3,
      views: 138,
      date: 'Nov. 3, 2025',
      description: 'Apartamento 303 de 163.31 metros cuadrados ubicado en el tercer piso del Edificio K58. Cuenta con sala, cocina,Cuarto de servicio con baño interno , pequeño espacio para área de labor, cuarto, baño y clóset. servicios al día, internet y cable incluidos.',
      details: {
        habitaciones: 3,
        baños: 3,
        areaConstruida: '163.31 m²',
        parqueaderos: 2
      },
      images: [

        '/images/702/1.jpeg',
        '/images/702/2.jpeg',
        '/images/702/3.jpeg',
        '/images/702/4.jpeg',
        '/images/702/5.jpeg'
      ],
      features: [
        'Sala de estar',
        'Cocina equipada',
        'Espacio para área de labor',
        'Dormitorio con clóset',
        'Baño completo',
        'Internet incluido',
        'Cable incluido',
        'Servicios al día',
        '2 Parqueadero privado',
        'Vigilancia 24/7',
        'Terraza',
        'Aire central ambos',
        'Parqueadero de visitantes'
      ],
      agent: {
        name: 'Jose Daniel Martinez',
        phone: '3022966560',
        email: 'josedanielmartinez2@gmail.com',
        avatar: 'https://inmobiliaria.kosari.net/storage/captura-de-pantalla-2025-09-22-142633-150x150.png',
        properties: 'Más propiedades de este agente'
      },
      videoUrl: 'https://www.youtube.com/embed/-24ufqGjX50',
      coordinates: {
        lat: 11.00957,
        lng: -74.81189
      }
    }
    ,
    'apartamento-403': {
      id: 'apartamento-403',
      title: 'Apartamento 403',
      location: 'Carrera 58 # 82-41, Edificio K58, Barranquilla, Colombia',
      price: '$1.500.000.000',
      priceType: 'Venta',
      type: 'Apartamento',
      category: 'Apartamento',
      bedrooms: 3,
      bathrooms: 3,
      area: '163.31 m²',
      floors: 4,
      views: 138,
      date: 'Nov. 3, 2025',
      description: 'Apartamento 403 de 163.31 metros cuadrados ubicado en el cuarto piso del Edificio K58. Cuenta con sala, cocina,Cuarto de servicio con baño interno , pequeño espacio para área de labor, cuarto, baño y clóset. servicios al día, internet y cable incluidos.',
      details: {
        habitaciones: 3,
        baños: 3,
        areaConstruida: '163.31 m²',
        parqueaderos: 2
      },
      images: [

        '/images/702/1.jpeg',
        '/images/702/2.jpeg',
        '/images/702/3.jpeg',
        '/images/702/4.jpeg',
        '/images/702/5.jpeg'
      ],
      features: [
        'Sala de estar',
        'Cocina equipada',
        'Espacio para área de labor',
        'Dormitorio con clóset',
        'Baño completo',
        'Internet incluido',
        'Cable incluido',
        'Servicios al día',
        '2 Parqueadero privado',
        'Vigilancia 24/7',
        'Terraza',
        'Aire central ambos',
        'Parqueadero de visitantes'
      ],
      agent: {
        name: 'Jose Daniel Martinez',
        phone: '3022966560',
        email: 'josedanielmartinez2@gmail.com',
        avatar: 'https://inmobiliaria.kosari.net/storage/captura-de-pantalla-2025-09-22-142633-150x150.png',
        properties: 'Más propiedades de este agente'
      },
      videoUrl: 'https://www.youtube.com/embed/-24ufqGjX50',
      coordinates: {
        lat: 11.00957,
        lng: -74.81189
      }
    }
  };
  const sendContactMessage = async (formData) => {
    try {
      setFormStatus({ loading: true, success: false, error: false, message: '' });
      
      const response = await axios.post(API_BASE_URL, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || 'No proporcionado',
        message: formData.message,
        property: formData.property,
        propertyId: property.id,
        _subject: `🔔 Nueva consulta: ${formData.property}`,
        _replyto: formData.email,
        _format: 'plain'
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        timeout: 15000,
      });

      return response.data;
    } catch (error) {
      console.error('Error enviando mensaje:', error);
      throw error;
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Manejar envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus({
        loading: false,
        success: false,
        error: true,
        message: 'Por favor completa los campos obligatorios (*)'
      });
      return;
    }

    try {
      const dataToSend = {
        ...formData,
        propertyId: property.id,
        propertyTitle: property.title,
        timestamp: new Date().toISOString()
      };

      const result = await sendContactMessage(dataToSend);
      
      setFormStatus({
        loading: false,
        success: true,
        error: false,
        message: '¡Mensaje enviado correctamente! Nos pondremos en contacto contigo pronto.'
      });

      // Resetear formulario
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: '',
        property: property.title
      });

      // Limpiar mensaje de éxito después de 5 segundos
      setTimeout(() => {
        setFormStatus(prev => ({ ...prev, message: '' }));
      }, 5000);

    } catch (error) {
      let errorMessage = 'Error al enviar el mensaje. Por favor intenta nuevamente.';
      
      if (error.response) {
        // Error del servidor
        errorMessage = error.response.data.message || `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.request) {
        // Error de conexión
        errorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión a internet.';
      }
      
      setFormStatus({
        loading: false,
        success: false,
        error: true,
        message: errorMessage
      });
    }
  };
   useEffect(() => {
    // Cargar datos del apartamento según el ID
    const propertyData = propertiesData[id];
    if (propertyData) {
      setProperty(propertyData);
      // Pre-cargar el nombre de la propiedad en el formulario
      setFormData(prev => ({
        ...prev,
        property: propertyData.title
      }));
    }
  }, [id]);
   const FormStatusMessage = () => {
    if (!formStatus.message) return null;

    return (
      <div className={`form-status ${formStatus.success ? 'success' : ''} ${formStatus.error ? 'error' : ''}`}>
        {formStatus.message}
        {formStatus.loading && <div className="loading-spinner"></div>}
      </div>
    );
  };

  const nextImage = () => {
    setActiveImage((prev) => (prev + 1) % property.images.length);
  };

  const prevImage = () => {
    setActiveImage((prev) => (prev - 1 + property.images.length) % property.images.length);
  };

  if (!property) {
    return <div className="loading">Cargando información del apartamento...</div>;
  }

  return (
    <div className="property-detail">
      <div className="container">
        {/* Header con título y estadísticas */}
        <div className="property-header">
          <div className="property-title-section">
            <h1>{property.title}</h1>
            <div className="property-stats">
              <div className="stat">
                <ViewIcon />
                <span>{property.views} puntos de vista</span>
              </div>
              <div className="stat">
                <CalendarIcon />
                <span>{property.date}</span>
              </div>
            </div>
          </div>
          <div className="property-location-price">
            <p className="location">{property.location}</p>
            <div className="price-section">
              <span className="price">{property.price}</span>
              <span className="price-type">{property.priceType}</span>
              {property.alquiler && (
                <span className="rent"> Mes {property.alquiler} alquiler</span>
              )}
            </div>
          </div>
        </div>

        {/* Galería con slider */}
        <div className="property-gallery">
          <div className="gallery-main">
            <div className="main-image-container">
              <img 
                src={property.images[activeImage]} 
                alt={property.title} 
                className="main-image"
              />
              <button className="nav-button prev" onClick={prevImage}>
                ‹
              </button>
              <button className="nav-button next" onClick={nextImage}>
                ›
              </button>
              <div className="image-counter">
                {activeImage + 1} / {property.images.length}
              </div>
            </div>
          </div>
          
          <div className="thumbnail-gallery">
            {property.images.map((image, index) => (
              <div 
                key={index} 
                className={`thumbnail ${activeImage === index ? 'active' : ''}`}
                onClick={() => setActiveImage(index)}
              >
                <img src={image} alt={`Vista ${index + 1} - ${property.title}`} />
              </div>
            ))}
          </div>
        </div>

        <div className="property-content">
          <div className="main-content">
            {/* Descripción General con iconos */}
            <section className="overview-section">
              <h2>Descripción general</h2>
              <div className="overview-grid">
                <div className="overview-item">
                  <div className="overview-icon">
                    <CategoryIcon />
                  </div>
                  <div className="overview-content">
                    <span className="label">Categoría</span>
                    <span className="value">{property.category}</span>
                  </div>
                </div>
                <div className="overview-item">
                  <div className="overview-icon">
                    <AreaIcon />
                  </div>
                  <div className="overview-content">
                    <span className="label">Área Construida</span>
                    <span className="value">{property.area}</span>
                  </div>
                </div>
                <div className="overview-item">
                  <div className="overview-icon">
                    <BedIcon />
                  </div>
                  <div className="overview-content">
                    <span className="label">Habitaciones</span>
                    <span className="value">{property.bedrooms}</span>
                  </div>
                </div>
                <div className="overview-item">
                  <div className="overview-icon">
                    <BathIcon />
                  </div>
                  <div className="overview-content">
                    <span className="label">Baños</span>
                    <span className="value">{property.bathrooms}</span>
                  </div>
                </div>
                <div className="overview-item">
                  <div className="overview-icon">
                    <FloorIcon />
                  </div>
                  <div className="overview-content">
                    <span className="label">Piso</span>
                    <span className="value">{property.floors}</span>
                  </div>
                </div>
                <div className="overview-item">
                  <div className="overview-icon">
                    <PriceIcon />
                  </div>
                  <div className="overview-content">
                    <span className="label">Precio</span>
                    <span className="value">{property.price}</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Descripción */}
            <section className="description-section">
              <h2>Descripción</h2>
              <p>{property.description}</p>
              <div className="details-list">
                <div className="detail-item">
                  <strong>Habitaciones:</strong> {property.details.habitaciones}
                </div>
                <div className="detail-item">
                  <strong>Baños:</strong> {property.details.baños}
                </div>
                <div className="detail-item">
                  <strong>Área Construida:</strong> {property.details.areaConstruida}
                </div>
                <div className="detail-item">
                  <strong>Parqueaderos:</strong> {property.details.parqueaderos}
                </div>
              </div>
            </section>

            {/* Características */}
            <section className="features-section">
              <h2>Características del Apartamento y Edificio</h2>
              <div className="features-grid">
                {property.features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <span className="feature-dot"></span>
                    {feature}
                  </div>
                ))}
              </div>
            </section>

            {/* Video */}
            <section className="video-section">
              <h2>Video del Apartamento</h2>
              <div className="video-container">
                <iframe
                  width="100%"
                  height="400"
                  src={property.videoUrl}
                  title={`Video del ${property.title}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </section>

            {/* Mapa */}
            <section className="map-section">
              <h2>Ubicación</h2>
              <div className="map-container">
                <iframe
                  width="100%"
                  height="400"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  src={`https://maps.google.com/maps?q=${property.coordinates.lat},${property.coordinates.lng}&z=16&output=embed`}
                  title={`Ubicación de ${property.title}`}
                ></iframe>
              </div>
              <div className="location-details">
                <h4>Dirección exacta:</h4>
                <p>{property.location}</p>
              </div>
            </section>
          </div>

          {/* Sidebar con agente y formulario */}
          <div className="sidebar">
            {/* Información del Agente */}
            <div className="agent-card">
              <h3>Contactar agencia</h3>
              <div className="agent-profile">
                <div className="agent-avatar">
                  <img 
                    src={property.agent.avatar} 
                    alt={property.agent.name}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/150x150/007bff/ffffff?text=JD';
                    }}
                  />
                </div>
                <div className="agent-info">
                  <div className="agent-name">{property.agent.name}</div>
                  <div className="agent-phone">
                    <PhoneIcon />
                    {property.agent.phone}
                  </div>
                  <div className="agent-email">
                    <EmailIcon />
                    {property.agent.email}
                  </div>
                  <div className="agent-properties">
                    <PropertiesIcon />
                    {property.agent.properties}
                  </div>
                </div>
              </div>
            </div>

            {/* Formulario de Contacto */}
            <div className="contact-form-card">
              <h3>Contacto</h3>
               <FormStatusMessage />
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre *</label>
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required 
                  disabled={formStatus.loading}
                />
              </div>
              <div className="form-group">
                <label>Teléfono</label>
                <input 
                  type="tel" 
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  disabled={formStatus.loading}
                />
              </div>
              <div className="form-group">
                <label>Correo electrónico *</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required 
                  disabled={formStatus.loading}
                />
              </div>
              <div className="form-group">
                <label>Propiedad de interés</label>
                <input 
                  type="text" 
                  name="property"
                  value={formData.property || property.title}
                  onChange={handleInputChange}
                  readOnly 
                />
              </div>
              <div className="form-group">
                <label>Mensaje *</label>
                <textarea 
                  rows="4" 
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required 
                  placeholder="Estoy interesado en este apartamento..."
                  disabled={formStatus.loading}
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="submit-button"
                disabled={formStatus.loading}
              >
                {formStatus.loading ? 'Enviando...' : 'Enviar Consulta'}
              </button>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetail;